type AnyRecord = Record<string, any>

export const normalizeId = <T extends AnyRecord>(item: T): T & { id?: string } => ({
  ...item,
  id: item.id ?? item._id ?? item.uuid ?? item.uid,
})

export const normalizeList = <T extends AnyRecord>(items: T[] = []): Array<T & { id?: string }> =>
  items.map(normalizeId)
